import { HomeCover } from "../../models/homeCoverDto";
import CustomCarousel from "../carousel/custom-carousel";
import styles from "./cover.module.scss";

const Cover: React.FC<{ homeCover: HomeCover; carouselItems: Array<any> }> = ({ homeCover, carouselItems }) =>
  homeCover && (
    <>
      {homeCover.type === "IMAGE" && <img className={styles["cover-image"]} src={homeCover.homeCoverImages[0].url} alt="cover" />}
      {homeCover.type === "CAROUSEL" && <CustomCarousel items={carouselItems} />}
      {homeCover.type === "TEXT" && (
        <div className={styles["cover-text-image__wrapper"]}>
          {homeCover.homeCoverImages.length > 0 && <img className={styles["cover-text-image__image"]} src={homeCover.homeCoverImages[0].url} alt="cover-text" />}
          <div className={styles["cover-text-image__text"]}>
            <h6>{homeCover.titre}</h6>
            <p>{homeCover.description}</p>
          </div>
        </div>
      )}
    </>
  );

export default Cover;
